import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { MainLayout } from '../components/Layout';
import MachineTable from '../components/Inventory/MachineTable';
import EquipmentsTable from '../components/Inventory/EquipmentsTable';
import InventoryTable from '../components/Inventory/InventoryTable';
import WorkbenchTable from '../components/Inventory/WorkbenchTable'; // Import the new WorkbenchTable component
import TopBarComponent from '../components/Inventory/TopBar';
import SearchBar from '../components/Inventory/SearchBar';
import { useDispatch } from 'react-redux';
import InventoryCategoryAPIs from '../utilities/api/category/AdminInventoryCategoryList';
import InventoryGroupAPIs from '../utilities/api/group/AdminInventoryGroupList';
import InventoryLocationAPIs from '../utilities/api/location/AdminLocationList';
import {
  getCategorySuccess,
  getCategoryFail,
} from '../redux/slices/categorySlice';
import {
  getLocationSuccess,
  getLocationFail,
} from '../redux/slices/locationSlice';
import { getGroupSuccess, getGroupFail } from '../redux/slices/groupSlice';

const Inventory = ({ collapsed, setCollapsed }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [category, setCategory] = useState('');
  const [group, setGroup] = useState('');
  const [tag, setTag] = useState('');
  const [status, setStatus] = useState('All');
  const [supervised, setSupervised] = useState('All');
  const [update, setUpdate] = useState(false);
  const [flag, setFlag] = useState(false);
  const [machinesData, setMachinesData] = useState([]);
  const [equipmentsData, setEquipmentsData] = useState([]);
  const [inventoriesData, setInventoriesData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const response = InventoryCategoryAPIs.CategoryListGet();
    response
      .then(result => {
        dispatch(getCategorySuccess(result));
      })
      .catch(error => {
        dispatch(getCategoryFail(error));
      });
  }, [flag]);

  useEffect(() => {
    const response = InventoryGroupAPIs.GroupListGet();
    response
      .then(result => {
        dispatch(getGroupSuccess(result));
      })
      .catch(error => {
        dispatch(getGroupFail(error));
      });
  }, [flag]);

  useEffect(() => {
    const response = InventoryLocationAPIs.LocationListGet();
    response
      .then(result => {
        dispatch(getLocationSuccess(result));
      })
      .catch(error => {
        dispatch(getLocationFail(error));
      });
  }, [flag]);

  const [renderedTabs, setRenderedTabs] = useState([0]);

  useEffect(() => {
    if (!renderedTabs.includes(activeTab)) {
      setRenderedTabs(prev => [...prev, activeTab]);
    }
    // Optionally reset status and supervised filters when changing tabs to prevent confusion
    setStatus('All');
    setSupervised('All');
  }, [activeTab]);

  const renderTable = (tabIndex) => {
    if (!renderedTabs.includes(tabIndex)) return null;

    const isHidden = activeTab !== tabIndex;

    return (
      <Box sx={{ display: isHidden ? 'none' : 'block' }}>
        {tabIndex === 0 && (
          <MachineTable
            searchQuery={searchQuery}
            category={category}
            group={group}
            tag={tag}
            update={update}
            setUpdate={setUpdate}
            flag={flag}
            setFlag={setFlag}
            setTableDataProp={setMachinesData}
            status={status}
            supervised={supervised}
          />
        )}
        {tabIndex === 1 && (
          <EquipmentsTable
            searchQuery={searchQuery}
            category={category}
            update={update}
            setUpdate={setUpdate}
            flag={flag}
            setFlag={setFlag}
            setTableDataProp={setEquipmentsData}
            status={status}
            supervised={supervised}
          />
        )}
        {tabIndex === 2 && (
          <InventoryTable
            searchQuery={searchQuery}
            category={category}
            group={group}
            tag={tag}
            update={update}
            setUpdate={setUpdate}
            flag={flag}
            setFlag={setFlag}
            setTableDataProp={setInventoriesData}
            status={status}
            supervised={supervised}
          />
        )}
        {tabIndex === 3 && (
          <WorkbenchTable
            searchQuery={searchQuery}
            update={update}
            setUpdate={setUpdate}
            flag={flag}
            setFlag={setFlag}
          />
        )}
      </Box>
    );
  };

  return (
    <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          overflow: 'auto',
        }}
      >
        <TopBarComponent
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          update={update}
          setUpdate={setUpdate}
          flag={flag}
          setFlag={setFlag}
          groups={group}
          machinesProp={machinesData}
          equipmentsProp={equipmentsData}
          inventoriesProp={inventoriesData}
        />
        <SearchBar
          activeTab={activeTab}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          category={category}
          setCategory={setCategory}
          group={group}
          setGroup={setGroup}
          tag={tag}
          setTag={setTag}
          status={status}
          setStatus={setStatus}
          supervised={supervised}
          setSupervised={setSupervised}
        />
        {renderTable(0)}
        {renderTable(1)}
        {renderTable(2)}
        {renderTable(3)}
      </Box>
    </MainLayout>
  );
};

export default Inventory;
